import {create} from "zustand"
import {GET_ADVANCE_FILTERS_URL} from "../utilities/API";
import {IFilterFetchResult, IFilterKeyWord, IFilterPlace, IFilterType, IFilterYear} from "../models/advanseFilter";
import useAlertStore from "./alertStore";

interface ICashFilterState {
    years: IFilterYear[],
    types:IFilterType[],
    places:IFilterPlace[],
    keyWords:IFilterKeyWord[],
}

interface IFilterState{
    years: IFilterYear[],
    types:IFilterType[],
    places:IFilterPlace[],
    keyWords:IFilterKeyWord[],
    isLoading:boolean,
    error:string | null,
    isOpen:boolean,
    cash:Map<string, ICashFilterState>,
    getFilterData: (search?:string | null,idKeyWords?:string | null, author?:string | null, place?:string | null,
                    yearFrom?:number | null, yearTo?:number | null, year?:number| null, type?:number | null, subType?:number | null,
                    signal?:AbortSignal) => void,
    toggleOpenStatus: () => void
}

const useFilterDataStore = create<IFilterState>((set)=>(
    {
        years:[],
        keyWords:[],
        types: [],
        places:[],
        cash:new Map<string, ICashFilterState>(),
        isOpen:false,
        isLoading:false,
        error: null,

        toggleOpenStatus : () =>{
            set({isOpen:!useFilterDataStore.getState().isOpen});
        },

        getFilterData : async (search?:string | null,idKeyWords?:string | null, author?:string | null, place?:string | null,
                               yearFrom?:number | null, yearTo?:number | null, year?:number| null, type?:number | null, subType?:number | null,
                               signal?:AbortSignal) =>{
            set({isLoading: true,error:null});

            let searchParam = search ? `&query=${search}` : '';
            let idKeyWordsParam = idKeyWords ? `&idkeywords=${idKeyWords}` : '';
            let authorNameParam = author ? `&authorname=${author}` : '';
            let yearFromParam = yearFrom ? `&yearfrom=${yearFrom}` : '';
            let yearToParam = yearTo ? `&yearto=${yearTo}` : '';
            let placeParam = place ? `&place=${place}` : '';
            let yearParam = year ? `&year=${year}` : '';
            let typeParam = type ? `&type=${type}` : '';
            let subTypeParam = subType ? `&subtype=${subType}` : '';
            let isAborted = false;

            let paramString = `${searchParam}${idKeyWordsParam}${searchParam}${authorNameParam}${yearFromParam}
                                                     ${yearToParam}${yearParam}${typeParam}${placeParam}${subTypeParam}`;

            const Url = GET_ADVANCE_FILTERS_URL+`?t=0${paramString}`;
            let cash = useFilterDataStore.getState().cash.get(Url);
            if(cash)
            {
                set({
                    years:cash.years,
                    keyWords:cash.keyWords,
                    types:cash.types,
                    places:cash.places,
                    isLoading:false
                });
                return;
            }

            try{
                console.log(Url);
                await fetch(Url,{signal}).then(async (response)=>{
                    let result = (await response.json()) as IFilterFetchResult;
                    set({years:result.data.years,
                               places:result.data.places,
                               types:result.data.types,
                                keyWords: result.data.keyWords,
                                isLoading:false
                              })

                    useFilterDataStore.getState().cash.set(Url,{
                        years:result.data.years,
                        places:result.data.places,
                        types:result.data.types,
                        keyWords: result.data.keyWords
                    });
                }).catch((e)=>{
                    if(e.message === "The user aborted a request.")
                    {
                        isAborted = true
                    }
                    else
                    {
                        set({error: "Не удалось загрузить данные",isLoading:false})
                        useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:"Не удалось загрузить данные фильтров"},2000)
                    }
                })
            }
            catch (e) {
                useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:"Не удалось загрузить данные фильтров!"},2000)
            }

        }
    }
))

export default useFilterDataStore